import { render, staticRenderFns } from "./UnitInformation.vue?vue&type=template&id=23ea4f96&scoped=true&"
import script from "./UnitInformation.vue?vue&type=script&lang=js&"
export * from "./UnitInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea4f96",
  null
  
)

export default component.exports